import React from 'react';
import {useObservationImages} from "../../../helpers/useObservationImages";
import BigYearPlayer from "./big-year-player";
import {usePageTitle} from "../../../helpers/usePageTitle";
import type {BigYearExplorerProps} from "./types";

export default function BigYearExplorer({
    observations,
    speciesImages,
    year,
    familyByTaxonomicOrder,
    lookupByTaxonomicOrder
}: BigYearExplorerProps) {
    const { setObservationImages } = useObservationImages(speciesImages, lookupByTaxonomicOrder);
    const yearLabel = year ? `${year} Big Year` : 'Big Year';

    usePageTitle(yearLabel, 'Discover');

    return (
        <BigYearPlayer
            observations={observations}
            setObservationImages={setObservationImages}
            year={year}
            familyByTaxonomicOrder={familyByTaxonomicOrder}
        />
    );
}
